import { render, staticRenderFns } from "./IstType.vue?vue&type=template&id=a9c5ca2e"
import script from "./IstType.vue?vue&type=script&lang=js"
export * from "./IstType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports